import { makeTask } from './utils';
import { themes } from './theme';

const MAX_DEPTH = 5;

export default function SubTaskList({ tasks, onChange, depth = 1, theme = themes.light }) {
  function update(idx, patch) {
    onChange(tasks.map((t, i) => i === idx ? { ...t, ...patch } : t));
  }

  function remove(idx) {
    onChange(tasks.filter((_, i) => i !== idx));
  }

  function addSub(idx) {
    const task = tasks[idx];
    update(idx, { subtasks: [...(task.subtasks || []), makeTask()], expanded: true });
  }

  return (
    <div style={{
      marginLeft: depth > 1 ? 16 : 0,
      borderLeft: depth > 1 ? `2px solid ${theme.primarySoft}` : 'none',
      paddingLeft: depth > 1 ? 10 : 0,
    }}>
      {tasks.map((task, idx) => {
        const hasSubs = task.subtasks && task.subtasks.length > 0;
        return (
          <div key={task.id} style={{ marginBottom: 4 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <button onClick={() => update(idx, { done: !task.done })} style={{
                width: 15,
                height: 15,
                borderRadius: 3,
                border: `1.5px solid ${task.done ? theme.success : theme.border}`,
                background: task.done ? theme.success : 'transparent',
                cursor: 'pointer',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                {task.done && <span style={{ color: '#ffffff', fontSize: 8, fontWeight: 900 }}>✓</span>}
              </button>

              <input
                value={task.text}
                onChange={e => update(idx, { text: e.target.value })}
                placeholder="Subtask"
                style={{
                  flex: 1,
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  color: task.done ? theme.faint : theme.text,
                  fontSize: 13,
                  textDecoration: task.done ? 'line-through' : 'none',
                  fontFamily: 'inherit',
                  fontWeight: task.text ? 600 : 500,
                  minWidth: 0,
                }}
              />

              <button onClick={() => update(idx, { showComment: !task.showComment })}
                title="Note"
                style={tinyButton(Boolean(task.comment), theme)}
              >✦</button>

              {depth < MAX_DEPTH && (
                <button
                  onClick={() => {
                    if (!hasSubs) addSub(idx);
                    else update(idx, { expanded: !task.expanded });
                  }}
                  title={hasSubs ? 'Collapse subtasks' : 'Add subtask'}
                  style={subtaskButton(hasSubs, theme)}
                >
                  {task.expanded ? '-' : '+'}
                </button>
              )}

              <button onClick={() => remove(idx)} style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: theme.faint,
                fontSize: 12,
                padding: 2,
                fontFamily: "'Orbitron', sans-serif",
                fontWeight: 900,
              }}
              onMouseEnter={e => e.target.style.color = theme.danger}
              onMouseLeave={e => e.target.style.color = theme.faint}
              >×</button>
            </div>

            {task.showComment && (
              <textarea
                value={task.comment || ''}
                onChange={e => update(idx, { comment: e.target.value })}
                placeholder="Comment or reason..."
                rows={2}
                style={{
                  width: '100%',
                  marginTop: 4,
                  background: theme.surfaceSoft,
                  border: `1px solid ${theme.border}`,
                  borderRadius: 4,
                  color: theme.text,
                  fontSize: 11,
                  padding: '4px 8px',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  boxSizing: 'border-box',
                  outline: 'none',
                }}
              />
            )}

            {task.expanded && hasSubs && (
              <div style={{ marginTop: 4 }}>
                <SubTaskList
                  tasks={task.subtasks}
                  onChange={subs => update(idx, { subtasks: subs, expanded: subs.length > 0 })}
                  depth={depth + 1}
                  theme={theme}
                />
                <button onClick={() => addSub(idx)} style={{
                  marginTop: 4,
                  background: theme.secondarySoft,
                  border: `1px dashed ${theme.secondary}`,
                  borderRadius: 4,
                  color: theme.secondary,
                  fontSize: 11,
                  cursor: 'pointer',
                  padding: '2px 8px',
                  fontFamily: 'inherit',
                  fontWeight: 800,
                }}>▸ subtask</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function tinyButton(active, theme) {
  return {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: active ? theme.primary : theme.faint,
    fontSize: 14,
    padding: 2,
    fontWeight: 900,
    minWidth: 16,
    fontFamily: "'Orbitron', sans-serif",
  };
}

function subtaskButton(active, theme) {
  return {
    width: 20,
    height: 20,
    borderRadius: 6,
    border: `1px solid ${active ? theme.primary : theme.border}`,
    background: active ? theme.primarySoft : theme.surfaceSoft,
    color: active ? theme.primary : theme.faint,
    cursor: 'pointer',
    fontSize: 13,
    lineHeight: '16px',
    padding: 0,
    fontWeight: 900,
    fontFamily: "'Orbitron', sans-serif",
    flexShrink: 0,
  };
}
